module.exports = __webpack_public_path__ + "48430d9ae2234f2f6df993a3a37f3d10.MP3";